import {
  BooleanInput,
  Edit,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin';

export const CommandParameterEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const record = useRecordContext();

  const onSuccess = () => {
    notify('Parameter updated successfully');
    redirect(`/commands/${record?.command_id}`);
  };

  return (
    <Edit mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <TextInput source="command_id" disabled />
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput source="display_name" validate={[required()]} fullWidth />
        <TextInput source="description" multiline rows={3} fullWidth />
        <SelectInput
          source="data_type"
          choices={[
            { id: 'string', name: 'String' },
            { id: 'integer', name: 'Integer' },
            { id: 'boolean', name: 'Boolean' },
            { id: 'array', name: 'Array' },
            { id: 'object', name: 'Object' },
          ]}
          validate={[required()]}
        />
        <SelectInput
          source="ui_component"
          choices={[
            { id: 'text', name: 'Text Input' },
            { id: 'textarea', name: 'Text Area' },
            { id: 'number', name: 'Number Input' },
            { id: 'select', name: 'Select (Single)' },
            { id: 'multiselect', name: 'Multi-Select' },
            { id: 'checkbox', name: 'Checkbox' },
            { id: 'radio', name: 'Radio Buttons' },
          ]}
          validate={[required()]}
        />
        <BooleanInput source="is_required" />
        <NumberInput source="order" validate={[required()]} />
        <TextInput source="default_value" fullWidth />
        <TextInput source="validation_rules" multiline rows={2} fullWidth helperText="JSON validation rules" />
      </SimpleForm>
    </Edit>
  );
};
